import "./s26.css";
import { Nav26 } from "../components/s26/Nav26";
import { Hero26 } from "../components/s26/Hero26";
import { Marcador26 } from "../components/s26/Marcador26";
import { Historia26 } from "../components/s26/Historia26";
import { Competicion26 } from "../components/s26/Competicion26";
import { Partido26 } from "../components/s26/Partido26";
import { Estadisticas26 } from "../components/s26/Estadisticas26";
import { Galeria26 } from "../components/s26/Galeria26";
import { Plantilla26 } from "../components/s26/Plantilla26";
import { Traje26 } from "../components/s26/Traje26";
import { Multimedia26 } from "../components/s26/Multimedia26";
import { Anterior26 } from "../components/s26/Anterior26";
import { Footer26 } from "../components/s26/Footer26";

// Página principal: Temporada septiembre 2026.
export const Temporada26 = () => (
  <div className="s26 min-h-screen">
    <Nav26 />
    <main>
      <Hero26 />
      <Marcador26 />
      <Historia26 />
      <Competicion26 />
      <Partido26 />
      <Estadisticas26 />
      <Plantilla26 />
      <Traje26 />
      <Galeria26 />
      <Multimedia26 />
      <Anterior26 />
    </main>
    <Footer26 />
  </div>
);
